// ! This file was auto-generated from the atlas OpenAPI schema. Do not override this file.
import { Tags } from "./tags.autogen";
export const endpoints = {
    createGuideline: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Guidelines, id: "LIST" }]
    },
    createPlaybook: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Playbooks, id: "LIST" }]
    },
    createQuestionGroup: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Question_Groups, id: "LIST" }]
    },
    createSavedQuestion: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Saved_Questions, id: "LIST" }]
    },
    deleteGuideline: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Guidelines, id: arg.guidelineId }, { type: Tags.Guidelines, id: "LIST" }]
    },
    deletePlaybook: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Playbooks, id: arg.playbookId }, { type: Tags.Playbooks, id: "LIST" }]
    },
    deleteQuestionGroup: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Question_Groups, id: arg.questionGroupId }, { type: Tags.Question_Groups, id: "LIST" }]
    },
    deleteSavedQuestion: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Saved_Questions, id: arg.savedQuestionId }, { type: Tags.Saved_Questions, id: "LIST" }]
    },
    exportPlaybook: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Playbooks, id: arg.playbookId }, { type: Tags.Playbooks, id: "LIST" }]
    },
    getGuidelineById: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Guidelines, id: arg.guidelineId }]
    },
    getGuidelinePlaybooks: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Guidelines, id: arg.guidelineId }]
    },
    getHealthLiveness: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Healthchecks, id: "LIST" }]
    },
    getHealthReadiness: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Healthchecks, id: "LIST" }]
    },
    getPlaybookAccess: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Playbooks, id: arg.playbookId }]
    },
    getPlaybookAnalyticsById: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Playbooks, id: arg.playbookId }]
    },
    getPlaybookById: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Playbooks, id: arg.playbookId }]
    },
    getPlaybookList: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Playbooks, id: "LIST" }]
    },
    getPlaybookTemplateById: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Playbooks, id: arg.templateId }]
    },
    getQuestionGroupById: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Question_Groups, id: arg.questionGroupId }]
    },
    getSavedQuestionById: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Saved_Questions, id: arg.savedQuestionId }]
    },
    listGuidelines: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Guidelines, id: "LIST" }]
    },
    listPlaybooks: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Playbooks, id: "LIST" }]
    },
    listPlaybookTemplates: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Playbooks, id: "LIST" }]
    },
    listQuestionGroups: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Question_Groups, id: "LIST" }]
    },
    listQuestionsByQuestionGroupId: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Question_Groups, id: arg.questionGroupId }]
    },
    listSavedQuestions: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Saved_Questions, id: "LIST" }]
    },
    postPlaybookAnalytics: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Playbooks, id: "LIST" }]
    },
    setPlaybookAccess: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Playbooks, id: arg.playbookId }, { type: Tags.Playbooks, id: "LIST" }]
    },
    updateGuideline: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Guidelines, id: arg.guidelineId }, { type: Tags.Guidelines, id: "LIST" }]
    },
    updatePlaybook: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Playbooks, id: arg.playbookId }, { type: Tags.Playbooks, id: "LIST" }]
    },
    updateQuestionGroup: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Question_Groups, id: arg.questionGroupId }, { type: Tags.Question_Groups, id: "LIST" }]
    },
    updateSavedQuestion: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Saved_Questions, id: arg.savedQuestionId }, { type: Tags.Saved_Questions, id: "LIST" }]
    },
    validateImportPlaybook: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Playbooks, id: "LIST" }]
    }
} as const;
